import {FC} from "react";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import {TextFieldProps} from "@mui/material/TextField/TextField";


type TSearchField = TextFieldProps & {
    onClear: () => void
}
export const SearchField: FC<TSearchField> = ({onClear, children, ...props}) => {


    return (
        <TextField
            placeholder={'Search'}
            // size={"small"}
            onBlur={(props.value as string || '').trim() === '' ? onClear : undefined}
            InputProps={{
                endAdornment: (
                    <InputAdornment position={'end'}>
                        {(props.value === '' || props.value === null || props.value === undefined) ? <SearchIcon /> : <IconButton sx={{padding: '0'}} disabled={props.disabled} onClick={() => {
                            onClear()
                        }}><ClearIcon /></IconButton>}
                    </InputAdornment>
                )
            }}
            {...props}
        >{children}</TextField>
    )
}